import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Lock, Mail, ArrowRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative">
      <div className="grid-lines absolute inset-0 opacity-30" />
      <motion.form onSubmit={submit} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
        className="relative w-full max-w-sm card-dark rounded-2xl p-8 glow-gold" data-testid="admin-login-form">
        <div className="flex justify-center mb-8"><Logo /></div>
        <h1 className="font-heading font-bold text-2xl text-white text-center">Area riservata</h1>
        <p className="text-slate-500 text-sm text-center mb-8">Accesso consulenti DM Solutions Group</p>

        <div className="space-y-4">
          <div>
            <Label className="text-slate-300 text-sm mb-2 flex items-center gap-1.5"><Mail className="h-3.5 w-3.5 text-slate-500" /> Email</Label>
            <Input data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@dmsolutions.it" className="input-dark h-11" />
          </div>
          <div>
            <Label className="text-slate-300 text-sm mb-2 flex items-center gap-1.5"><Lock className="h-3.5 w-3.5 text-slate-500" /> Password</Label>
            <Input data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••" className="input-dark h-11" />
          </div>
        </div>

        <Button type="submit" disabled={loading} data-testid="admin-login-btn"
          className="w-full mt-7 h-11 rounded-xl bg-gold-500 hover:bg-gold-400 text-[#0A1A2F] font-semibold group">
          {loading ? "Accesso…" : "Accedi"}
          {!loading && <ArrowRight className="h-4 w-4 ml-1.5 group-hover:translate-x-1 transition-transform" />}
        </Button>
      </motion.form>
    </div>
  );
}
